import React from 'react';

import './IconV1.scss';

export const IconV1 = ({
  className='',
  icon,
  altText = 'img',
  size = 'regular',
  styles={}
}: {
  className?: string;
  icon?: string;
  altText?: string;
  size?: string;
  styles?: React.CSSProperties
}) => {
  return (
    <img
      className={`iqc-dl-icon-${size} ${className}`}
      src={icon}
      alt={altText}
      style={{ ...styles }}
    />
  );
};

